module.exports = __webpack_public_path__ + "img/left-image.74299ce9.svg";